import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type ApiSalesOrderLineItem = QueryAtomResult<
  typeof salesOrderLineItemsQueryAtom
>['lineItems'][number];

export const salesOrderLineItemsQueryAtom = createQueryAtomFactory(
  'trade.salesOrderLineItems',
  (params: { salesOrderId: string }) => ({
    salesOrders: {
      __args: {
        filter: {
          includeLineItems: true,
          ids: [params.salesOrderId],
        },
        pagination: {
          limit: 1,
          offset: 0,
        },
      },
      entries: {
        id: true,
        documentNumber: true,
        account: {
          id: true,
          name: true,
        },
        lineItems: {
          id: true,
          item: {
            id: true,
            name: true,
            description: true,
          },
          unit: true,
          unitPrice: {
            amount: true,
            currencyCode: true,
          },
          totalPrice: {
            amount: true,
            currencyCode: true,
          },
          quantity: true,
        },
      },
    },
  }),
  {
    select: (data) => {
      if (!data?.salesOrders?.entries?.[0]) {
        return { lineItems: [] };
      }

      const salesOrder = data.salesOrders.entries[0];
      return {
        documentNumber: salesOrder.documentNumber ?? null,
        account: salesOrder.account,
        lineItems: salesOrder.lineItems ?? [],
      };
    },
  },
);
